// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "التنظيف",
    laundry: "الغسيل",
    maintenance: "الصيانة والإصلاحات",
    supplies: "المستلزمات والمستهلكات",
    utilities: "المرافق",
    staff: "الموظفون",
    software: "البرمجيات والأدوات",
    marketing: "التسويق",
    taxes: "الضرائب والرسوم",
    other: "أخرى",
  },

  restricted: "مصروفات الإدارة متاحة للحساب الرئيسي فقط: وصولك يقتصر على بعض أماكن الإقامة.",

  summary: {
    aria: "ملخص مصروفات الفترة. اختر رقمًا لتصفية الجدول.",
    total: "إجمالي المصروفات",
    count: "عدد المصروفات: {n}",
    charged: "مُحمَّلة على الملّاك",
    chargedHint: "تُخصم من كشوف حساباتهم",
    own: "خاصة بالإدارة",
    ownHint: "تُخصم من أرباحك",
  },

  toolbar: {
    search: "بحث",
    searchPlaceholder: "الوصف أو المورّد",
    clearSearch: "مسح البحث",
    category: "الفئة",
    allCategories: "الكل",
    listing: "مكان الإقامة",
    allListings: "الكل",
    type: "النوع",
    allTypes: "الكل",
    charged: "مُحمَّلة على المالك",
    own: "خاصة بالإدارة",
    create: "مصروف جديد",
  },

  table: {
    date: "التاريخ",
    category: "الفئة",
    concept: "الوصف",
    listing: "مكان الإقامة",
    chargedTo: "على حساب",
    amount: "المبلغ",
    receipt: "الإيصال",
    actions: "الإجراءات",
    general: "عام",
    management: "الإدارة",
    ownerMissing: "لا يوجد مالك معيّن",
    notCharged: "لم يعد مكان الإقامة تحت الإدارة: لا يُحمَّل المصروف على أحد",
    vat: "الضريبة {pct}%",
    download: "تنزيل الإيصال",
    edit: "تعديل",
    remove: "حذف",
  },

  empty: {
    title: "لا توجد مصروفات في هذه الفترة",
    text: "سجّل ما تدفعه (التنظيف، الغسيل، الإصلاحات، البرمجيات…) وحدّد ما إذا كان يُحمَّل على المالك أم أنه مصروف خاص بالإدارة.",
    create: "تسجيل مصروف",
    filteredTitle: "لا توجد مصروفات تطابق عوامل التصفية",
    filteredText: "جرّب بحثًا آخر أو أزل عوامل التصفية لعرض كل مصروفات الفترة.",
    clear: "إزالة عوامل التصفية",
  },

  load: {
    error: "تعذّر تحميل المصروفات.",
    retry: "إعادة المحاولة",
  },

  remove: {
    title: "هل تريد حذف هذا المصروف؟",
    message: "لن يُحتسب «{concept}» ({amount}) بعد الآن في التحليلات ولا في كشوف حساب الملّاك.",
    confirm: "حذف",
    done: "تم حذف المصروف",
    error: "تعذّر حذف المصروف. حاول مرة أخرى.",
  },

  receiptError: "تعذّر تنزيل الإيصال.",

  drawer: {
    newTitle: "مصروف جديد",
    editTitle: "تعديل المصروف",
    newSubtitle: "ما تدفعه مقابل الإدارة، على حساب المالك أو على حساب شركة الإدارة.",
    editSubtitle: "تظهر التغييرات فورًا في التحليلات وفي كشوف الحساب.",
    close: "إغلاق",
    sections: {
      expense: "المصروف",
      listing: "مكان الإقامة والمالك",
      notes: "ملاحظات",
      receipt: "الإيصال أو الفاتورة",
    },
    fields: {
      concept: "الوصف",
      conceptPlaceholder: "مثال: تنظيف بعد المغادرة",
      category: "الفئة",
      date: "التاريخ",
      supplier: "المورّد",
      supplierPlaceholder: "مثال: مغسلة الشمس",
      amount: "المبلغ",
      vat: "ضريبة القيمة المضافة",
      vatHint: "للعلم فقط: المبلغ هو ما دفعته شاملًا ضريبة القيمة المضافة.",
      listing: "مكان الإقامة",
      listingGeneral: "مصروف عام للإدارة (بدون مكان إقامة)",
      unit: "الوحدة",
      unitAll: "مكان الإقامة بالكامل",
      notesPlaceholder: "أي تفصيل تريد تذكّره",
    },
    charge: {
      label: "تحميل المصروف على المالك",
      general: "المصروف العام يكون دائمًا على حساب الإدارة. اختر مكان إقامة لتحميله على مالكه.",
      loading: "جارٍ التحقق من مكان الإقامة…",
      error: "تعذّر التحقق مما إذا كان مكان الإقامة هذا تحت الإدارة.",
      retry: "إعادة المحاولة",
      notManaged: "مكان الإقامة هذا غير مُعلَّم كمُدار: يُحتسب المصروف على حسابك.",
      notManagedMarked: "لم يعد مكان الإقامة تحت الإدارة: لا يُحمَّل المصروف على أحد. أوقف هذا الخيار لإبقائه مصروفًا خاصًا بك.",
      own: "إذا لم تحمّله على المالك، يُحتسب مصروفًا خاصًا بالإدارة.",
      owner: "سيُخصم من كشف حساب {owner}.",
      noOwner: "لا يوجد مالك معيّن لمكان الإقامة بعد: سيُخصم من كشف حساب من تعيّنه.",
    },
    receipt: {
      drop: "اسحب الصورة أو ملف PDF إلى هنا",
      pick: "أو اختر ملفًا",
      formats: "JPG أو PNG أو WEBP أو HEIC أو PDF · بحد أقصى 10 ميغابايت",
      current: "الإيصال المحفوظ",
      download: "تنزيل",
      change: "استبدال",
      remove: "إزالة",
      undo: "تراجع",
      willRemove: "ستتم إزالة الإيصال عند الحفظ.",
      willReplace: "سيحل محل الإيصال المحفوظ",
      tooBig: "حجم الملف أكبر من 10 ميغابايت.",
      badType: "صيغة غير مدعومة: ارفع صورة (JPG أو PNG أو WEBP أو HEIC) أو ملف PDF.",
    },
    errors: {
      required: "هذا الحقل مطلوب.",
      category: "اختر فئة.",
      amount: "أدخل مبلغًا أكبر من 0.",
      vat: "أدخل نسبة بين 0 و100.",
      review: "راجع الحقول المحددة.",
      generic: "تعذّر حفظ المصروف. حاول مرة أخرى.",
    },
    discard: {
      title: "هل تريد تجاهل التغييرات؟",
      message: "سيضيع ما أدخلته في هذا المصروف.",
      confirm: "تجاهل",
      cancel: "متابعة التعديل",
    },
    cancel: "إلغاء",
    save: "حفظ المصروف",
    saveChanges: "حفظ التغييرات",
    saving: "جارٍ الحفظ…",
    created: "تم حفظ المصروف",
    updated: "تم حفظ التغييرات",
    outOfPeriod: "تم الحفظ. تاريخه ({date}) خارج الفترة المعروضة.",
  },
};
